export default function arrayBuffer2BinStr(buffer: ArrayBuffer) {
  const bufView = new Uint8Array(buffer);
  let str = '';
  for (let i = 0; i < buffer.byteLength; i++) {
    str += String.fromCharCode(bufView[i]);
  }
  return str;
}
